import React from 'react'
import PropTypes from 'prop-types'
import { Button, ButtonGroup, Spinner } from 'react-bootstrap'

const HINTS = {
  include: 'Show transactions with this flag',
  exclude: 'Hide transactions with this flag'
}

// Off, Include or Exclude for one analytic's flag. `value` is null when off. Shared by the grid's
// analytic column header and the AND/OR group builder.
const AnalyticFlagChoice = ({ value = null, onChange, disabled = false, isPending = false }) => {
  const choice = (option, label) => (
    <Button
      variant={value === option ? 'primary' : 'light'}
      size="sm"
      onClick={() => onChange(option)}
      disabled={disabled || isPending}
      data-testid={`analytic-flag-${option || 'off'}`}
    >
      {label}
    </Button>
  )

  return (
    <div className="mb-3">
      <div className="mb-2 d-flex align-items-center gap-2">
        <strong className="small">Filter</strong>
        {isPending && <Spinner animation="border" size="sm" variant="primary" role="status" />}
      </div>
      <ButtonGroup className="w-100">
        {choice(null, 'Off')}
        {choice('include', 'Include')}
        {choice('exclude', 'Exclude')}
      </ButtonGroup>
      <div className="mt-2 small text-muted">{HINTS[value] || 'No filter applied'}</div>
    </div>
  )
}

AnalyticFlagChoice.propTypes = {
  value: PropTypes.oneOf([null, 'include', 'exclude']),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  isPending: PropTypes.bool
}

export default AnalyticFlagChoice
